module.exports = __webpack_public_path__ + "img/Elven_Sword_01.16145adf.png";